import { getWorkspaceBaseUrl } from "../utils/StudioRoute.utils.js";
import NavigationService from "@ane/core/lib/services/NavigationService";
import { WORKSPACE_ID } from "@ane/core/lib/constants/QueryString.constants";
import { WindowLocation } from "@ane/core/lib/services/WindowService";
import { ROUTES } from "./Routes.constants.js";
import { isPathKnownRoute } from "./Route.utils.js";
const getOnboardingPagePath = () => {
  return `${ROUTES.onboarding.location.pathname}`;
};
const workspaceTenantSelectorRoute = (workspaceId) => {
  const studioPath = workspaceId ? getWorkspaceBaseUrl(workspaceId) : "";
  if (!!studioPath) {
    return getStudioWorkspaceSelectionPath(studioPath);
  } else {
    return getControlTowerWorkpsaceSelectionPath();
  }
};
const getControlTowerWorkpsaceSelectionPath = () => {
  return NavigationService.getCustomQueryParams(`${ROUTES.workspaceSelector.location.pathname}`, WindowLocation.search);
};
const getStudioWorkspaceSelectionPath = (studioPath) => {
  return NavigationService.getCustomQueryParamsOmitingSomeParams(
    `${studioPath}${ROUTES.workspaceSelector.location.pathname}`,
    [WORKSPACE_ID],
    WindowLocation.search
  );
};
const isOnboardingPathname = (pathname = WindowLocation.pathname) => {
  return isPathKnownRoute([ROUTES.tenant, ROUTES.onboarding], pathname);
};
const isWorkspaceOrTenantRoute = (pathname = WindowLocation.pathname) => {
  return isPathKnownRoute([ROUTES.tenant, ROUTES.workspaceSelector], pathname);
};
export {
  getControlTowerWorkpsaceSelectionPath,
  getOnboardingPagePath,
  getStudioWorkspaceSelectionPath,
  isOnboardingPathname,
  isWorkspaceOrTenantRoute,
  workspaceTenantSelectorRoute
};
//# sourceMappingURL=WorkspaceTenantSelectorRoute.utils.js.map
